import { httpsCallable } from "firebase/functions";
import { functions } from ".";
import { isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import { toPhoneNumberDigitsOnly } from "../utils/stringFormatter";
import { toLower } from "lodash";

export const validatePhone = async (phone) => {
    if (isStringNotEmpty(phone)) {
        const func = httpsCallable(functions, "validatephone", { timeout: 6000000 });

        const res = await func({ phone: toPhoneNumberDigitsOnly(phone) });

        // console.log(res.data);
        return res.data;
    }

    return null;
};

export const validateEmail = async (email) => {
    if (isStringNotEmpty(email)) {
        const func = httpsCallable(functions, "validateemail", { timeout: 6000000 });

        const res = await func({ email: toLower(email) });

        // console.log(res.data);
        return res.data;
    }

    return null;
};

export const validateIPAddress = async (ip) => {
    if (isStringNotEmpty(ip)) {
        const func = httpsCallable(functions, "validateip", { timeout: 6000000 });

        const res = await func({ ip: ip });

        // console.log(res.data);

        let apiRes = { ...res.data };
        if (isObjectNotEmpty(apiRes)) {
            if (isStringNotEmpty(apiRes.fraud_score)) {
                apiRes.fraud_chance = apiRes.fraud_score;
            }

            return apiRes;
        }
    }

    return null;
};